"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var contexts_1 = require("../../contexts");
var ContentWrapper_1 = tslib_1.__importDefault(require("./ContentWrapper"));
var FooterBackground_1 = tslib_1.__importDefault(require("./FooterBackground"));
var LinkSection_1 = tslib_1.__importDefault(require("./LinkSection"));
var AppLogo_1 = require("../AppLogo");
var FlexGrid_1 = require("../FlexGrid");
var Link_1 = require("../Link");
var Text_1 = require("../Text");
var FooterPhone_1 = tslib_1.__importDefault(require("./FooterPhone"));
var textColor = 'rgba(255, 255, 255, 0.6)';
var links = [
    {
        label: 'Privacy',
        href: 'https://www.alintaenergy.com.au/help-and-support/terms-and-conditions/privacy-policy'
    },
    {
        label: 'Terms and Conditions',
        href: 'https://www.alintaenergy.com.au/help-and-support/terms-and-conditions'
    },
    {
        label: 'Contact Us',
        href: 'https://www.alintaenergy.com.au/help-and-support/help-and-support/customer-support/contact-us'
    }
];
var AppFooter = function (_a) {
    var children = _a.children, phone = _a.phone;
    var currentSize = react_1.useContext(contexts_1.ResponsiveContext);
    var isXsScreen = currentSize === 'xs';
    var itemPadding = isXsScreen ? { top: 'small' } : { left: 'medium' };
    return (react_1.default.createElement(FooterBackground_1.default, { "aria-label": "standard footer" },
        react_1.default.createElement(ContentWrapper_1.default, null,
            phone ? react_1.default.createElement(FooterPhone_1.default, { phone: phone }) : null,
            children),
        react_1.default.createElement(LinkSection_1.default, null,
            react_1.default.createElement(FlexGrid_1.FlexGrid, { alignItems: isXsScreen ? 'start' : 'center', direction: isXsScreen ? 'column' : 'row' },
                react_1.default.createElement(FlexGrid_1.FlexGridItem, { md: true },
                    react_1.default.createElement(Link_1.Link, { size: "small", href: "https://www.alintaenergy.com.au/", textUnderline: false, color: textColor },
                        react_1.default.createElement(AppLogo_1.AppLogo, { size: currentSize, src: "https://www.alintaenergy.com.au/-/media/alinta-website/data/media/img/alinta_white_logo.svg", alt: "Alinta Energy logo" }))),
                links.map(function (_a, index) {
                    var label = _a.label, href = _a.href;
                    return (react_1.default.createElement(FlexGrid_1.FlexGridItem, { md: "auto", pad: itemPadding, key: index },
                        react_1.default.createElement(Link_1.Link, { size: "small", href: href, textUnderline: false, color: textColor }, label)));
                }),
                react_1.default.createElement(FlexGrid_1.FlexGridItem, { md: "auto", pad: itemPadding },
                    react_1.default.createElement(Text_1.Text, { size: "small", color: textColor },
                        "\u00A9 Alinta Energy ",
                        new Date().getFullYear()))))));
};
exports.default = AppFooter;
//# sourceMappingURL=AppFooter.js.map